import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const logosCarrosel1 = [
  '/img/logos/mysql.svg',
  '/img/logos/javascript.svg',
  '/img/logos/php.svg',
  '/img/logos/react.svg',
];

const logosCarrosel2 = [
  '/img/logos/jquery.svg',
  '/img/logos/azure.svg',
  '/img/logos/mysql.svg',
  '/img/logos/node.js.svg',
];

const logosCarrosel3 = [
  '/img/logos/java.svg',
  '/img/logos/html.svg',
  '/img/logos/css.svg',
  '/img/logos/wordpress.svg',

];

const Wrapper = styled.div`
  margin-bottom: 40px;
`;

const ImageSlide = styled.div`
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  
  img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
  }
`;

const CarrosselMultiplo = () => {
  const baseSettings = {
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    arrows: false,
  };

  return (
    <>
      {/* Carrossel 1 - Direita */}
      <Wrapper>
        <Slider {...{ ...baseSettings, rtl: false }}>
          {logosCarrosel1.map((logo, i) => (
            <ImageSlide key={i}>
              <img src={logo} alt={`Logo ${i + 1}`} />
            </ImageSlide>
          ))}
        </Slider>
      </Wrapper>

      {/* Carrossel 2 - Esquerda */}
      <Wrapper>
        <Slider {...{ ...baseSettings, rtl: true }}>
          {logosCarrosel2.map((logo, i) => (
            <ImageSlide key={i}>
              <img src={logo} alt={`Logo ${i + 1}`} />
            </ImageSlide>
          ))}
        </Slider>
      </Wrapper>

      {/* Carrossel 3 - Direita */}
      <Wrapper>
        <Slider {...{ ...baseSettings, rtl: false }}>
          {logosCarrosel3.map((logo, i) => (
            <ImageSlide key={i}>
              <img src={logo} alt={`Logo ${i + 1}`} />
            </ImageSlide>
          ))}
        </Slider>
      </Wrapper>
    </>
  );
};

export default CarrosselMultiplo;
